import type { ListingSearchParams } from '../types/permalink-page.types';

const DEFAULT_PASS_THROUGH_KEYS = [
  'ratings',
  'tags',
  'statuses',
  'universes',
  'characters',
  'page',
  'sort',
] as const;

export const buildPermalinkPassThroughSearchParams = (
  params: ListingSearchParams,
  omitKeys: readonly string[] = [],
): URLSearchParams => {
  const searchParams = new URLSearchParams();
  for (const key of DEFAULT_PASS_THROUGH_KEYS) {
    if (omitKeys.includes(key)) continue;
    const value = params[key];
    if (value) searchParams.set(key, String(value));
  }
  return searchParams;
};

export const appendSearchParams = (basePath: string, searchParams: URLSearchParams): string => {
  const queryStr = searchParams.toString();
  return queryStr ? `${basePath}?${queryStr}` : basePath;
};
